// Publishes the Add-User form's view complexity ('simple' | 'full') so the
// walkthrough can gate its "choose Full view" step (the toggle is local React
// state with no DOM reflection). Single-instance app, so a module store is fine.

export type UserFormComplexity = 'simple' | 'full';

type Listener = () => void;

let complexity: UserFormComplexity = 'simple';
const listeners = new Set<Listener>();

export const setUserFormComplexity = (value: UserFormComplexity): void => {
	if (complexity === value) return;
	complexity = value;
	listeners.forEach((l) => l());
};

export const subscribeUserFormComplexity = (
	listener: Listener,
): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

export const getUserFormComplexity = (): UserFormComplexity => complexity;
